// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "ReportAViolation" + "." + "0f42252f" + ".chunk.css";
};